import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { PostRecruitmentService } from '../../../modules/service/post-recruitment/post-recruitment.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CompensationService } from 'src/app/modules/service/compensation/compensation.service';
import { DatePipe } from '@angular/common';
import { CommonService } from '../../../modules/service/common/common.service';
import { PersonalDataService } from '../../../modules/service/personal-data/personal-data.service';
import { differenceInCalendarDays } from 'date-fns';
import { ManagementDataService } from '../../../modules/service/management-data/management-data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'management-table',
  templateUrl: './management-table.component.html',
  styleUrls: ['./management-table.component.less'],
  providers: [DatePipe],
})
export class ManagementTableComponent implements OnInit, OnChanges {
  @Input() type; // 未通过/拒绝
  @Input() managementDataDataType = 1; // 猎头/面试官
  @Input() headhuntingList = []; // 猎头列表
  @Input() interviewerList = []; // 面试官列表
  http = {
    //  获取邀约猎头今日初复试不通过 总计
    getHeadhuntingNoPassTodayCount: () => {
      this.managementDataService
        .getHeadhuntingNoPassTodayCount({
          type: this.managementDataType,
          invitation_uid:
            this.managementDataHeadhuntingId.length == this.headhuntingList.length ? '' : this.managementDataHeadhuntingId.join(','),
        })
        .then((res) => {
          this.headFn(res);
          this.http.getHeadhuntingNoPassTodayList();
        });
    },
    //  获取邀约猎头今日初复试不通过列表
    getHeadhuntingNoPassTodayList: () => {
      this.managementDataService
        .getHeadhuntingNoPassTodayList({
          type: this.managementDataType,
          invitation_uid:
            this.managementDataHeadhuntingId.length == this.headhuntingList.length ? '' : this.managementDataHeadhuntingId.join(','),
          page: this.managementDataPage,
          page_num: this.managementDataPageSize,
        })
        .then((res) => {
          this.managementDataCreateTime = res.create_at;
          this.listFn(res);
        });
    },
    //  获取邀约猎头初复试不通过列表 总计
    getHeadhuntingNoPassAllCount: () => {
      this.managementDataService
        .getHeadhuntingNoPassAllCount({
          type: this.managementDataType,
          invitation_uid:
            this.managementDataHeadhuntingId.length == this.headhuntingList.length ? '' : this.managementDataHeadhuntingId.join(','),
          start_time: this.datePipe.transform(this.managementDataDate[0], 'yyyy-MM-dd'),
          end_time: this.datePipe.transform(this.managementDataDate[1], 'yyyy-MM-dd'),
        })
        .then((res) => {
          this.headFn(res);
          this.http.getHeadhuntingNoPassList();
        });
    },
    //  获取邀约猎头初复试不通过列表
    getHeadhuntingNoPassList: () => {
      this.managementDataService
        .getHeadhuntingNoPassList({
          type: this.managementDataType,
          invitation_uid:
            this.managementDataHeadhuntingId.length == this.headhuntingList.length ? '' : this.managementDataHeadhuntingId.join(','),
          start_time: this.datePipe.transform(this.managementDataDate[0], 'yyyy-MM-dd'),
          end_time: this.datePipe.transform(this.managementDataDate[1], 'yyyy-MM-dd'),
          page: this.managementDataPage,
          page_num: this.managementDataPageSize,
        })
        .then((res) => {
          this.listFn(res);
        });
    },

    //  获取面试官面试今日不通过 总计
    getInterviewerNoPassTodayCount: () => {
      this.managementDataService
        .getInterviewerNoPassTodayCount({
          type: this.managementDataType,
          invitation_uid:
            this.managementDataHeadhuntingId.length == this.headhuntingList.length ? '' : this.managementDataHeadhuntingId.join(','),
        })
        .then((res) => {
          this.headFn(res);
          this.http.getInterviewerNoPassTodayList();
        });
    },
    //  获取面试官面试今日不通过列表
    getInterviewerNoPassTodayList: () => {
      this.managementDataService
        .getInterviewerNoPassTodayList({
          type: this.managementDataType,
          invitation_uid:
            this.managementDataHeadhuntingId.length == this.headhuntingList.length ? '' : this.managementDataHeadhuntingId.join(','),
          page: this.managementDataPage,
          page_num: this.managementDataPageSize,
        })
        .then((res) => {
          this.managementDataCreateTime = res.create_at;
          this.listFn(res);
        });
    },
    //  获取面试官面试不通过 总计
    getInterviewerNoPassAllCount: () => {
      this.managementDataService
        .getInterviewerNoPassAllCount({
          type: this.managementDataType,
          invitation_uid:
            this.managementDataHeadhuntingId.length == this.headhuntingList.length ? '' : this.managementDataHeadhuntingId.join(','),
          start_time: this.datePipe.transform(this.managementDataDate[0], 'yyyy-MM-dd'),
          end_time: this.datePipe.transform(this.managementDataDate[1], 'yyyy-MM-dd'),
        })
        .then((res) => {
          this.headFn(res);
          this.http.getInterviewerNoPassList();
        });
    },
    // 获取面试官面试不通过列表
    getInterviewerNoPassList: () => {
      this.managementDataService
        .getInterviewerNoPassList({
          type: this.managementDataType,
          invitation_uid:
            this.managementDataHeadhuntingId.length == this.headhuntingList.length ? '' : this.managementDataHeadhuntingId.join(','),
          start_time: this.datePipe.transform(this.managementDataDate[0], 'yyyy-MM-dd'),
          end_time: this.datePipe.transform(this.managementDataDate[1], 'yyyy-MM-dd'),
          page: this.managementDataPage,
          page_num: this.managementDataPageSize,
        })
        .then((res) => {
          this.listFn(res);
        });
    },

    //  获取猎头面试今日拒绝 总计
    getHeadhuntingNoAcceptTodayCount: () => {
      this.managementDataService
        .getHeadhuntingNoAcceptTodayCount({
          type: this.managementDataType,
          invitation_uid:
            this.managementDataHeadhuntingId.length == this.headhuntingList.length ? '' : this.managementDataHeadhuntingId.join(','),
        })
        .then((res) => {
          this.headFn(res);
          this.http.getHeadhuntingNoAcceptTodayList();
        });
    },
    //  获取猎头面试今日拒绝列表
    getHeadhuntingNoAcceptTodayList: () => {
      this.managementDataService
        .getHeadhuntingNoAcceptTodayList({
          type: this.managementDataType,
          invitation_uid:
            this.managementDataHeadhuntingId.length == this.headhuntingList.length ? '' : this.managementDataHeadhuntingId.join(','),
          page: this.managementDataPage,
          page_num: this.managementDataPageSize,
        })
        .then((res) => {
          this.managementDataCreateTime = res.create_at;
          this.listFn(res);
        });
    },
    //  获取猎头面试拒绝总计 总计
    getHeadhuntingNoAcceptAllCount: () => {
      this.managementDataService
        .getHeadhuntingNoAcceptAllCount({
          type: this.managementDataType,
          invitation_uid:
            this.managementDataHeadhuntingId.length == this.headhuntingList.length ? '' : this.managementDataHeadhuntingId.join(','),
          start_time: this.datePipe.transform(this.managementDataDate[0], 'yyyy-MM-dd'),
          end_time: this.datePipe.transform(this.managementDataDate[1], 'yyyy-MM-dd'),
        })
        .then((res) => {
          this.headFn(res);
          this.http.getHeadhuntingNoAcceptList();
        });
    },
    //  获取邀约猎头初复试拒绝列表
    getHeadhuntingNoAcceptList: () => {
      this.managementDataService
        .getHeadhuntingNoAcceptList({
          type: this.managementDataType,
          invitation_uid:
            this.managementDataHeadhuntingId.length == this.headhuntingList.length ? '' : this.managementDataHeadhuntingId.join(','),
          start_time: this.datePipe.transform(this.managementDataDate[0], 'yyyy-MM-dd'),
          end_time: this.datePipe.transform(this.managementDataDate[1], 'yyyy-MM-dd'),
          page: this.managementDataPage,
          page_num: this.managementDataPageSize,
        })
        .then((res) => {
          this.listFn(res);
        });
    },
  };
  // 面试未通过数据 猎头 面试官
  managementDataDateType = 1; // 面试未通过时间类型
  managementDataDateSearchType = 1; // 面试未通过时间类型 查询后
  managementDataDate = [new Date(new Date().setDate(new Date().getDate() - 7)), new Date(new Date().setDate(new Date().getDate() - 1))]; // 面试时间
  managementDataDataTypeF = 1;
  managementDataHeadhuntingShow = false; // 面试未通过 猎头弹窗
  managementDataHeadhuntingCheckData = []; // 面试未通过 猎头弹窗选中数据
  managementDataHeadhuntingId = []; // 面试未通过 猎头id
  managementDataDunfordShow = false; // 面试未通过 面试官弹窗
  managementDataDunfordCheckData = []; // 面试未通过 面试官弹窗选中数据
  managementDataDunfordId = []; // 面试未通过 面试官岗位id
  managementDataType = 1; // 面试未通过 初试/复试
  managementDataTypeList = [
    { id: 1, name: '初试未通过' },
    { id: 2, name: '复试未通过' },
    { id: 3, name: '入职未通过' },
  ];
  managementDataTotalCount: any = []; // 面试列表未通过 总数据
  managementDataTHeadList = []; // 面试未通过列表 表头
  managementDataList = []; // 面试未通过列表
  managementDataCreateTime = ''; // 面试未通过列表 数据更新时间
  managementDataPage = 1; // 面试未通过列表 当前页数
  managementDataTotal = 0; // 面试未通过列表 总条数
  managementDataPageSize = 20; // 面试未通过列表 每页条数

  constructor(
    private compensationService: CompensationService,
    private postrecruitmentservice: PostRecruitmentService,
    private message: NzMessageService,
    private datePipe: DatePipe,
    private common: CommonService,
    private personalDataService: PersonalDataService,
    private managementDataService: ManagementDataService,
    private router: Router,
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    // console.log(changes);
    if (changes['type']) {
      const _pageData = this.common.getCache('pageData');
      if (this.type == 1) {
        this.managementDataTypeList = [
          { id: 1, name: '初试未通过' },
          { id: 2, name: '复试未通过' },
          { id: 3, name: '入职未通过' },
        ];
        if (_pageData != null && _pageData['pageName'] == 'management-data' && _pageData['type'] == 3) {
          this.managementDataDateType = _pageData['managementDataDateType'];
          this.managementDataDateSearchType = _pageData['managementDataDateSearchType'];
          this.managementDataDate = [new Date(_pageData['managementDataDate'][0]), new Date(_pageData['managementDataDate'][1])];
          this.managementDataDataType = _pageData['managementDataDataType'];
          this.managementDataDataTypeF = _pageData['managementDataDataTypeF'];
          this.managementDataHeadhuntingCheckData = _pageData['managementDataHeadhuntingCheckData'];
          this.managementDataHeadhuntingId = _pageData['managementDataHeadhuntingId'];
          this.managementDataDunfordCheckData = _pageData['managementDataDunfordCheckData'];
          this.managementDataDunfordId = _pageData['managementDataDunfordId'];
          this.managementDataType = _pageData['managementDataType'];
          setTimeout(() => {
            this.managementDataPage = _pageData['managementDataPage'];
            this.managementDataPageSize = _pageData['managementDataPageSize'];
            this.getList();
          });
        } else {
          this.managementDataSearchClick();
        }
      } else {
        this.managementDataTypeList = [
          { id: 1, name: '拒绝初试' },
          { id: 2, name: '拒绝复试' },
          { id: 3, name: '拒绝入职' },
        ];
        if (_pageData != null && _pageData['pageName'] == 'management-data' && _pageData['type'] == 4) {
          this.managementDataDateType = _pageData['managementDataDateType'];
          this.managementDataDateSearchType = _pageData['managementDataDateSearchType'];
          this.managementDataDate = [new Date(_pageData['managementDataDate'][0]), new Date(_pageData['managementDataDate'][1])];
          this.managementDataDataType = _pageData['managementDataDataType'];
          this.managementDataDataTypeF = _pageData['managementDataDataTypeF'];
          this.managementDataHeadhuntingCheckData = _pageData['managementDataHeadhuntingCheckData'];
          this.managementDataHeadhuntingId = _pageData['managementDataHeadhuntingId'];
          this.managementDataDunfordCheckData = _pageData['managementDataDunfordCheckData'];
          this.managementDataDunfordId = _pageData['managementDataDunfordId'];
          this.managementDataType = _pageData['managementDataType'];
          setTimeout(() => {
            this.managementDataPage = _pageData['managementDataPage'];
            this.managementDataPageSize = _pageData['managementDataPageSize'];
            this.getList();
          });
        } else {
          this.managementDataSearchClick();
        }
      }
    }
  }

  // 禁止选择未来时间
  disabledDate = (current: Date): boolean => {
    return differenceInCalendarDays(current, new Date(new Date().setDate(new Date().getDate() - 1))) > 0;
  };
  // table数据
  headFn(data: any): void {
    const arr = [];
    for (const i of data.labels) {
      arr.push(0);
      for (const j of data.list) {
        if (i.label_id == j.label_id) {
          arr.splice(arr.length - 1, 1);
          arr.push(j.count);
        }
      }
    }
    // console.log(arr);
    this.managementDataTHeadList = data.labels;
    this.managementDataTotalCount = arr;
  }
  listFn(data: any): void {
    // console.log(data);
    let uid = '';
    if (this.managementDataDataType == 1) {
      uid = 'invitation_uid';
    } else {
      uid = 'interviewer_uid';
    }
    const list = [];
    for (const i of data.user) {
      const arr = [];
      list.push({
        name: i.username,
        id: i.employee_id,
        arr,
      });
      for (const j of this.managementDataTHeadList) {
        if (data.list.length == 0) {
          arr.push(0);
        } else {
          arr.push(0);
          for (const k of data.list) {
            for (const v of k.label) {
              if (k.username[uid] == i.employee_id && v.label_id == j.label_id) {
                arr.splice(arr.length - 1, 1);
                arr.push(v.count);
              }
            }
          }
        }
      }
    }
    // console.log(list);
    this.managementDataList = list;
    // this.managementDataTHeadList = data.labels;
    this.managementDataTotal = data.count;
  }

  // 面试未通过数据 查询
  managementDataSearchClick(): void {
    if (this.managementDataDateType == 1) {
      // 今天
      this.managementDataDateSearchType = 1;
      this.managementDataPage = 1;
      if (this.type == 1) {
        if (this.managementDataDataType == 1) {
          this.http.getHeadhuntingNoPassTodayCount();
        } else {
          this.http.getInterviewerNoPassTodayCount();
        }
      } else {
        this.http.getHeadhuntingNoAcceptTodayCount();
      }
    } else {
      // 历史
      if (new Date(new Date(this.managementDataDate[0]).setMonth(this.managementDataDate[0].getMonth() + 3)) < this.managementDataDate[1]) {
        this.common.msg.create('warning', '只能查看时间长度在3个月内数据');
        return;
      }
      this.managementDataDateSearchType = 2;
      this.managementDataPage = 1;
      if (this.type == 1) {
        if (this.managementDataDataType == 1) {
          this.http.getHeadhuntingNoPassAllCount();
        } else {
          this.http.getInterviewerNoPassAllCount();
        }
      } else {
        this.http.getHeadhuntingNoAcceptAllCount();
      }
    }
    this.managementDataDataTypeF = this.managementDataDataType;
  }
  // 面试未通过数据 猎头人员删除
  managementDataHeadhuntingIdChange(): void {
    const arr = [];
    for (const i of this.managementDataHeadhuntingCheckData) {
      if (this.managementDataHeadhuntingId.indexOf(i.employee_id) != -1) {
        arr.push(i);
      }
    }
    this.managementDataHeadhuntingCheckData = arr;
  }
  // 面试未通过数据 猎头人员弹窗返回数据
  managementDataHeadhuntingSure($event: any): void {
    this.managementDataHeadhuntingId = [];
    for (const i of $event.target) {
      this.managementDataHeadhuntingId.push(i.employee_id);
    }
    this.managementDataHeadhuntingCheckData = $event.target;
    this.managementDataHeadhuntingShow = false;
  }
  // 面试未通过数据 面试官人员删除
  managementDataDunfordIdChange(): void {
    const arr = [];
    for (const i of this.managementDataDunfordCheckData) {
      if (this.managementDataDunfordId.indexOf(i.employee_id) != -1) {
        arr.push(i);
      }
    }
    this.managementDataDunfordCheckData = arr;
  }
  // 面试未通过数据 面试官人员弹窗返回数据
  managementDataDunfordSure($event: any): void {
    this.managementDataDunfordId = [];
    for (const i of $event.target) {
      this.managementDataDunfordId.push(i.employee_id);
    }
    this.managementDataDunfordCheckData = $event.target;
    this.managementDataDunfordShow = false;
  }
  // 面试未通过数据 初试/复试/入职
  managementDataTypeClick(type: any): void {
    this.managementDataType = type;
    this.getList();
  }
  // 面试未通过数据 分页
  managementDataPageChange(): void {
    this.getList();
  }

  getList(): void {
    if (this.managementDataDateSearchType == 1) {
      if (this.type == 1) {
        if (this.managementDataDataType == 1) {
          this.http.getHeadhuntingNoPassTodayCount();
        } else {
          this.http.getInterviewerNoPassTodayCount();
        }
      } else {
        this.http.getHeadhuntingNoAcceptTodayCount();
      }
    } else {
      if (this.type == 1) {
        if (this.managementDataDataType == 1) {
          this.http.getHeadhuntingNoPassAllCount();
        } else {
          this.http.getInterviewerNoPassAllCount();
        }
      } else {
        this.http.getHeadhuntingNoAcceptAllCount();
      }
    }
  }
  // 查看详情
  goReason(item: any): void {
    this.common.setCache('pageData', {
      pageName: 'management-data',
      type: this.type == 1 ? 3 : 4,
      managementDataDateType: this.managementDataDateType,
      managementDataDateSearchType: this.managementDataDateSearchType,
      managementDataDate: this.managementDataDate,
      managementDataDataType: this.managementDataDataType,
      managementDataDataTypeF: this.managementDataDataTypeF,
      managementDataHeadhuntingCheckData: this.managementDataHeadhuntingCheckData,
      managementDataHeadhuntingId: this.managementDataHeadhuntingId,
      managementDataDunfordCheckData: this.managementDataDunfordCheckData,
      managementDataDunfordId: this.managementDataDunfordId,
      managementDataType: this.managementDataType,
      managementDataPage: this.managementDataPage,
      managementDataPageSize: this.managementDataPageSize,
    });
    this.router.navigate(['/headhunter/headhunter-home/no-pass-reason'], {
      queryParams: {
        id: item.id,
        type: this.type,
        dataDataType: this.managementDataDataTypeF,
        dataType: this.managementDataType,
      },
    });
  }
}
